// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"6e829dee","70":"efa4c3e3","137":"235ddb8c","488":"c51013ff","523":"cfa1e3a2","555":"7c4932c0","741":"8501df28","755":"2d679b5e","785":"2674e876","895":"eb3641b6"}[chunkId] + ".chunk.js";
};